import React, { useEffect, useState } from "react";
import { usePropsInputs } from "../../../../hooks/useProps/usePropsInput";
import { usePropsSelect } from "../../../../hooks/useProps/usePropsSelect";
import { useSubmitForm } from "../../../../hooks/useSubmitForm/useSubmitForm";
import { crearSolicitudBonoTutoriaAPI } from "../../../../consumers/backendApisUrls";
import BaseSolicitudes from "./BaseSolicitudes";

const CrearSolicitudBonoTutoria = ({ toggleModal, refreshPage, DataCampanaBonoTutoria, fechasTutoria}) => {

    const SECTION_NAME = "CrearSolicitudBonoTutoria";
    const KEYS = {
        CampanaBonoTutoria: "CampanaBonoTutoria",
        FechaTutorFin: "FechaTutorFin",
        FechaTutorInicio: "FechaTutorInicio",
        IdCampanaBonoTutoria: "IdCampanaBonoTutoria",
        IdEmpleado: "IdEmpleado",
        IdSolicitudBonoTutoria: "IdSolicitudBonoTutoria",
        NombreCompleto: "NombreCompleto",
        NombreSede: "NombreSede",
        Cargo: "Cargo",
        IdCampanaBonoTutoria: "IdCampanaBonoTutoria",
        CampanaBonoTutoria: "CampanaBonoTutoria"
    };
    const [formValues, setFormValues] = useState({});
    const [commonProps] = usePropsInputs(formValues, setFormValues, SECTION_NAME);
    const [isLoading, setIsLoading] = useState(true);
    const [submitForm] = useSubmitForm();

    useEffect(() => {
           console.log(DataCampanaBonoTutoria)
        }, [DataCampanaBonoTutoria]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const api = crearSolicitudBonoTutoriaAPI();
        const payload = getPayload();
        try {
            await submitForm(
                Object.values(KEYS),
                api,
                payload,
                SECTION_NAME,
                successSubmit
            );
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const getPayload = () => {
        return {
            IdSolicitudBonoTutoria: formValues[KEYS.IdSolicitudBonoTutoria],
            FechaTutorInicio: formValues[KEYS.FechaTutorInicio],
            FechaTutorFin: formValues[KEYS.FechaTutorFin],
            IdCampanaBonoTutoria: DataCampanaBonoTutoria.value,
            IdEmpleado: formValues[KEYS.IdEmpleado],
        }
    }

    const successSubmit = async () => {
        toggleModal();
        await refreshPage();
    };
    return (
        <BaseSolicitudes
            title="Crear nueva Solicitud"
            toggleModal={toggleModal}
            handleSubmit={handleSubmit}
            sectionName={SECTION_NAME}
            formValues={formValues}
            setFormValues={setFormValues}
            commonProps={commonProps}
            KEYS={KEYS}
            nuevo={true}
            CampanaBonoTutoria= {DataCampanaBonoTutoria}
            fechasTutoria = {fechasTutoria}
        />)
}

export default CrearSolicitudBonoTutoria;